import React, { useEffect } from 'react'
import { graphql } from 'gatsby'
import shortid from 'shortid'
import Prism from 'prismjs'
import { get, startCase } from 'lodash'

import Layout from '../components/layout'
import SocialLinks from '../components/pages/blog/SocialLinks'
import LatestArticles from '../components/pages/blog/LatestArticles'
import TagsList from '../components/pages/blog/TagsList'
import Billboard from '../components/Billboard'
import Seo from '../components/seo'
import { ShareButtons } from '../components/pages/blog/share-buttons'
import { blogLink, tagLink } from '../utils/blog-utils'

import '../styles/prism.scss'

export const pageQuery = graphql`
  query PostsById($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        slug
        title
        createdAt(formatString: "LL")
        author
        tags
        featuredImage
        ogImage
        seo {
            title
            description
        }
      }
    }
  }
`

const renderTags = (tags) => {
    if (!tags) {
        return null
    }

    return (
        <ul>
            {tags.map((tag) => (
                <li key={shortid.generate()}>
                    <a href={tagLink(tag)}>{startCase(tag)}</a>
                </li>
            ))}
        </ul>
    )
}

const BlogPost = (props) => {

    const { markdownRemark: article } = props.data
    const ogImage = get(article, 'frontmatter.ogImage')
    const featuredImage = ogImage ? ogImage : get(article, 'frontmatter.featuredImage')

    useEffect(() => {
        Prism.highlightAll()
    }, [])

    return (
        <Layout>
            <Seo
                title={article.frontmatter.title}
                description={get(article, 'frontmatter.seo.description')}
                image={featuredImage ? featuredImage : null}
            />

            <Billboard className="Billboard--blogPost" color="white" />

            <section className="section blogWrap">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8">
                            <article className="article">
                                <h1 className="articlePage__title">{article.frontmatter.title}</h1>

                                <div className="articlePublished">
                                    {article.frontmatter.createdAt}
                                    {article.frontmatter.author && <span>&nbsp;by {article.frontmatter.author}</span>}
                                </div>

                                <div className="articleItem__tags">
                                    <span>TAGS:</span>

                                    {renderTags(article.frontmatter.tags)}
                                </div>

                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: article.html,
                                    }}
                                />
                            </article>
                        </div>

                        <div className="col-md-4">
                            <div className="blogSidebar">
                                <ShareButtons
                                    url={blogLink(article.frontmatter.slug, { relative: false })}
                                    title={article.frontmatter.title}
                                />
                                <LatestArticles />
                                <SocialLinks />
                                <TagsList />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    )
}

export default BlogPost
